import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("i", {
    class: _normalizeClass(['fas fa-solid arrow arrow-dynamic', _ctx.getTextColor, _ctx.getArrowIcon])
  }, null, 2))
}